module.exports = __webpack_public_path__ + "assets/mam.png?8779759d2d42e3b00f038e2dbae5f4cb";